import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class StorageService {
  setItem(key: string, value: string): void {
    localStorage.setItem(key, value);
  }

  setItemOf<T>(key: string, value: T): void {
    localStorage.setItem(key, JSON.stringify(value));
  }

  getItem(key: string): string | null {
    return localStorage.getItem(key);
  }

  getItemOf<T>(key: string): T | null {
    const item = localStorage.getItem(key);
    if (item)
      return JSON.parse(item) as T;
    return null;
  }

  removeItem(key: string): void {
    localStorage.removeItem(key);
  }

  clear(): void {
    localStorage.clear();
  }
}
